import { render, staticRenderFns } from "./ReadBlog.vue?vue&type=template&id=265cd37a&scoped=true"
import script from "./ReadBlog.vue?vue&type=script&lang=js"
export * from "./ReadBlog.vue?vue&type=script&lang=js"
import style0 from "./ReadBlog.vue?vue&type=style&index=0&id=265cd37a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265cd37a",
  null
  
)

export default component.exports